import { createSlice } from '@reduxjs/toolkit';

const courseDataSlice = createSlice({
  name: 'courseData',
  initialState: {
    data: [],
    aditionalData: [],
    usersInCourse: 0,
    accessCourse: null,
    userTrack: {},
    userAditionalTrack: {},
    lessonsCourse: {},
    missingActivities: null,
    courseReviews: {},
    userReview: {},
    userDegree: [],
    trailerCourse: {}
  },
  reducers: {
    info(state, action) {
      state.data = action.payload.info;
    },
    aditionalInfo(state, action) {
      state.aditionalData = action.payload.aditionalInfo.courseVO;
    },
    usersInCourse(state, action) {
      state.usersInCourse = action.payload.usersInCourse;
    },
    accessCourse(state, action) {
      state.accessCourse = action.payload.access;
    },
    userTrack(state, action) {
      state.userTrack = action.payload.track;
    },
    userAditionalTrack(state, action) {
      state.userAditionalTrack = action.payload.aditionalTrack;
    },
    lessonsCourse(state, action) {
      state.lessonsCourse = action.payload.lessonsCourse;
    },
    missingActivities(state, action) {
      state.missingActivities = action.payload.missingActivities;
    },
    courseReviews(state, action) {
      let reviewsStars = [];
      state.courseReviews = action.payload.courseReviews;
      if (action.payload.courseReviews.starGroups) {
        reviewsStars.push({
          value: action.payload.courseReviews.starGroups.fiveStars,
          star: 5
        });
        reviewsStars.push({
          value: action.payload.courseReviews.starGroups.fourStars,
          star: 4
        });
        reviewsStars.push({
          value: action.payload.courseReviews.starGroups.threeStars,
          star: 3
        });
        reviewsStars.push({
          value: action.payload.courseReviews.starGroups.twoStars,
          star: 2
        });
        reviewsStars.push({
          value: action.payload.courseReviews.starGroups.oneStar,
          star: 1
        });
      } else {
        reviewsStars.push({ value: 0, star: 5 });
        reviewsStars.push({ value: 0, star: 4 });
        reviewsStars.push({ value: 0, star: 3 });
        reviewsStars.push({ value: 0, star: 2 });
        reviewsStars.push({ value: 0, star: 1 });
      }
      state.courseReviews.reviewsStars = reviewsStars;
    },
    userReview(state, action) {
      state.userReview = action.payload.userReview;
    },
    userDegree(state, action) {
      state.userDegree = action.payload.userDegree;
    },
    trailerCourse(state, action) {
      state.trailerCourse = action.payload.trailerCourse;
    }
  }
});

export const courseDataActions = courseDataSlice.actions;

export default courseDataSlice;
